
import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getDocs, query, where, collection, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase.js";
import { Helmet } from "react-helmet";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext.jsx";
import './company.css';
import Loading from "../components_root/loading.jsx";
import { TbWindowMinimize, TbWindowMaximize } from "react-icons/tb";
import { GrDocumentConfig } from "react-icons/gr";
import Accounts_master from "./ledger_accounts_root/accounts_master";
import Account_statement from "./ledger_books_root/account_statement.jsx";
import Chart_details from "../cart_root/chart_details.jsx";
import product_icon from "../assets/product_icon.png";
import { MdHistory, MdOutlineInventory, MdOutlineManageAccounts, MdOutlineReceiptLong, MdOutlineWorkHistory, MdReceipt, MdSettings, MdWorkHistory } from "react-icons/md";
import Accounting_data from "./accounting_data.jsx";
import Voucher_master from "./vouchers_root/voucher_master.jsx";
import Vouchers_edit from "./vouchers_root/voucher_edit.jsx";
import Account_ledger from "./ledger_books_root/account_ledger.jsx";
import Receipt_transaction from "./receipt_transaction_root/receipt_transaction.jsx";
import Voucher_read from "./vouchers_root/voucher_read.jsx";
import { PiBooks } from "react-icons/pi";
import Cash_books from "./cash_book_root/cash_books.jsx";
import Cash_books_statement from "./cash_book_root/cash_books_statement.jsx";
import Voucher_withdrawal from "./voucher_entry_root/voucher_withdrawal.jsx";
import Voucher_deposit from "./voucher_entry_root/voucher_deposit.jsx";
import Delete_master from "./delete_master_root/delete_master.jsx";
import Log_history from "../log_history_root/log_history.jsx";
import Accounts_edit from "./ledger_accounts_root/accounts_edit.jsx";
import Voucher_entry from "./voucher_entry_root/voucher_entry.jsx";
import Vouchers_list_menu from "./vouchers_root/vouchers_list_menu.jsx";
import Voucher_data from "./vouchers_root/voucher_data.jsx";
import { VscDashboard } from "react-icons/vsc";
import Cashbook_withdrawal from "./voucher_entry_root/cashbook_withdrawal.jsx";
import Cashbook_deposit from "./voucher_entry_root/cashbook_deposit.jsx";
import Ledger_book_accounts_edit from "./ledger_books_root/ledger_book_accounts_edit.jsx";
import Upload_file from "./voucher_entry_root/upload-files.jsx";
import Printsetting_edit from "./print_setting_root/printsetting_edit.jsx";
import { Get_company_information } from "../company_root/get_company_information.js";
import { Verify_stafftype_account } from "../company_root/staff_account_root/verify_stafftype_account.js";
import Pos_receipt_master from "./pos_receipt_master_root/pos_receipt_master.jsx";
import Search_root from "../search_root/search.jsx";
import { IoIosSearch, IoMdCart, IoMdCheckmarkCircleOutline } from "react-icons/io";
import Stock_inventory from "./stock_inventory_root/stock_inventory.jsx";
import Home_page from "../home_root/home.jsx";
 
//reporting
import pos_receipt_summary from "./reporting_root/pos_receipt_summary.jsx";
import Balance_sheet from "./reporting_root/balance_sheet.jsx"; 
export const seo = {
    title: "AOOZ Accounting Software | Web & Mobile App for Payments, Stocks, Inventory & Staff Attendance",
    description: "AOOZ is a complete accounting software with web and mobile apps. Manage payments, stocks, staff attendance, inventory, and generate online share receipts. A powerful all-in-one platform for businesses.",
    keywords: "AOOZ accounting software, business accounting app, payment management, stock tracking, inventory software, staff attendance system, online share receipt, web accounting app, mobile accounting app",
    url: "https://aooz.in",
    image: "https://aooz.in/assets/logo.png"
};
export default function Accounting({ data }) {
    const servicetablename = "accountingfinancedb";
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [search, setSearch] = useState(window.location.search);
    const [categorynameTab, setCategorynameTab] = useState("accounting");
    const [IsLoading2, setIsLoading2] = useState(true);
    const [companyData, setCompanyData] = useState(null);
    const [activeTab, setActiveTab] = useState("home");
    const [userlogin, setuserlogin] = useState(false);
    const [guid, setGuid] = useState("");
    useEffect(() => {
        const existingsessiontoken = Cookies.get("sessiontoken");
        const guids = Cookies.get("guid");
        if (existingsessiontoken !== null && existingsessiontoken !== undefined && guids !== null && guids !== undefined) {
            setuserlogin(true);
            setGuid(guid);
        } else {
            setuserlogin(false);
             navigate("../login");
        }
    }, [navigate]);
    //staff account verify
    const [checking, setChecking] = useState(true);
    const [staffstatus, setStaffstatus] = useState(false);
    const [staffdata, setStaffdata] = useState([]);
    useEffect(() => {

        const verifyStaffAccount = async () => {
            const accountguid = Cookies.get("guid");
            const result = await Verify_stafftype_account(accountguid);
            if (result.success) {

                if (result.data.administration_login == false) {
                    navigate("/staff");
                    return;
                }

                setStaffdata({
                    staff: result.data,
                    accountinfo: result.accountinfo
                });
                setStaffstatus(true);
                setChecking(false);
            } else {
                setChecking(true);
            }
        };
        verifyStaffAccount();
    }, [userlogin, navigate]);

    // useEffect(() => {
    //     const loadCompany = async () => {
    //         const res = await Get_company_information("company");
    //         if (res.success) {
    //             setCompanyData(res.data);
    //         }
    //     };

    //     loadCompany();
    // }, []);
    // 🔹 Fetch vouchers
    const [vouchers_masterdata, setVouchers_masterdata] = useState([]);
    useEffect(() => {
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        const fetchCategories = async () => {
            setIsLoading2(true);

            try {
                // Query vouchers list
                const q = query(
                    collection(db, servicetablename, select_company_uid, "vouchers")
                );

                const snap = await getDocs(q);

                const uniquevouchers = snap.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                setVouchers_masterdata(uniquevouchers);

            } catch (err) {
                console.error("Error fetching products:", err);
                Toastshow("Error loading data");
            } finally {
                setIsLoading2(false);
            }
        };

        fetchCategories();
    }, []);
    //  //orderBy("date_time", "desc")
    useEffect(() => {
        const handleUrlChange = () => {
            setSearch(window.location.search);
        };

        window.addEventListener("popstate", handleUrlChange);

        return () => {
            window.removeEventListener("popstate", handleUrlChange);
        };
    }, []);
    useEffect(() => {
        const updateSearch = () => setSearch(window.location.search);

        window.addEventListener("popstate", updateSearch);

        // Patch replaceState and pushState
        const patchHistory = (method) => {
            const original = window.history[method];
            window.history[method] = function () {
                const result = original.apply(this, arguments);
                window.dispatchEvent(new Event("urlchange"));
                return result;
            };
        };

        patchHistory("replaceState");
        patchHistory("pushState");

        window.addEventListener("urlchange", updateSearch);

        return () => {
            window.removeEventListener("popstate", updateSearch);
            window.removeEventListener("urlchange", updateSearch);
        };
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(search);
        const tab = params.get("page");

        if (tab) {
            const t = tab.toLowerCase();
            setcategoryproductsTabInUrl(t);
            setCategorynameTab(t);
        } else {
            setCategorynameTab("accounting");
        }
    }, [search]);
    // 

    //brandname
    useEffect(() => {
        const params = new URLSearchParams(search);
        const tab = params.get("page");

        if (tab) {
            const t = tab.toLowerCase();
            setcategoryproductsTabInUrl(t);
            setCategorynameTab(t);
        } else {
            setCategorynameTab("accounting");
        }
    }, [search]);

    const setcategoryproductsTabInUrl = (tab) => {
        const params = new URLSearchParams(window.location.search);
        params.set("page", tab);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", newUrl);
    };

    const [collapsed, setCollapsed] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        };

        // Run once on mount
        handleResize();

        // Attach resize listener
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const Pages = {
        accounting: Accounting_data,
        vouchers_master: Voucher_master,
        accounts_master: Accounts_master,
        accounts_edit: Accounts_edit,
        account_ledger: Account_ledger,
        account_statement: Account_statement,
        vouchers_edit: Vouchers_edit,
        receipt_transaction: Receipt_transaction,
        voucher_read: Voucher_read,
        cash_books: Cash_books,
        cash_books_statement: Cash_books_statement,
        voucher_withdrawal: Voucher_withdrawal,
        voucher_deposit: Voucher_deposit,
        delete_master: Delete_master,
        log_history: Log_history,
        vouchers: Voucher_data,
        voucher_entry: Voucher_entry,
        cashbook_withdrawal: Cashbook_withdrawal,
        cashbook_deposit: Cashbook_deposit,
        ledger_book_accounts_edit: Ledger_book_accounts_edit,
        upload_file: Upload_file,
        printsetting_edit: Printsetting_edit,
        pos_receipt_master: Pos_receipt_master,
        search: Search_root,
        stock_inventory: Stock_inventory,
       pos_receipt_summary,
         balance_sheet: Balance_sheet
    };

    const ActivePage = Pages[categorynameTab] || null;
    const openEditVoucher = (uid) => {
        navigate(`accounting/?page=voucher&voucher_name=${uid}`, {
            state: { accountguid: uid }
        });
    };
    // ✅ SAFE

    return (
        <div >
            {userlogin === true ?
                (<>
                    <Helmet>
                        <title>{seo.title}</title>
                        <meta name="description" content={seo.description} />
                        <meta name="keywords" content={seo.keywords} />
                        <meta property="og:title" content={seo.title} />
                        <meta property="og:description" content={seo.description} />
                        <meta property="og:image" content={seo.image} />
                        <meta property="og:url" content={seo.url} />
                    </Helmet>


                    {/* <div className="products-body" > */}
                    {/* <div className="productsmenu " >
                            <div onClick={() => setCollapsed(!collapsed)} className={`menu-div b-bottom p-1  ${activeTab === "editcompany" ? "activemenu" : ""}`}  >
                                <table>
                                    <tr>
                                        <td width={40}   >
                                            <div className="menu-btn" >
                                                {collapsed ? <TbWindowMaximize className="icon-img" /> : <TbWindowMinimize className="icon-img" />}

                                            </div>
                                        </td>
                                        <td>
                                            {!collapsed && (

                                                <div className="menu-title bold text-h2 fcap"
                                                >
                                                    Menu
                                                </div>
                                            )}
                                        </td>
                                    </tr>

                                </table>


                            </div>

                            <div className="m-top">
                                <div title="Monitor" className={`ui-items cursor p-1 ${categorynameTab === "accounting" ? "menuactivemenu activemenu" : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("accounting");
                                        setcategoryproductsTabInUrl("accounting");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={50} className="items-center"><VscDashboard className="icon-img" /></td>


                                                {collapsed === false && (
                                                    <td className="productsmenu-pc text-h2 fcap">
                                                        <>Monitor</>
                                                    </td>
                                                )}
                                            
                                            </tr>



                                        </tbody>
                                    </table>
                                </div>
                                <div title="Monitor" className={`ui-items cursor p-1 ${categorynameTab === "search" ? "menuactivemenu activemenu" : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("search");
                                        setcategoryproductsTabInUrl("search");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40} className="items-center"><IoIosSearch className="icon-img" /></td>


                                                {collapsed === false && (
                                                    <td className="productsmenu-pc text-h2 fcap text-l">
                                                        Search
                                                    </td>
                                                )}

                                            </tr>
 

                                        </tbody>
                                    </table>
                                </div>

                                <div title="Log history" className={`ui-items cursor p-1 ${categorynameTab === "log_history" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("log_history");
                                        setcategoryproductsTabInUrl("log_history");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40} className="items-center"><MdOutlineWorkHistory className="icon-img" /></td>


                                                {collapsed === false && (
                                                    <td className="text-h2 fcap text-l">
                                                        Queue & Log
                                                    </td>
                                                )}

                                            </tr>
 

                                        </tbody>
                                    </table>
                                </div>
                                <div className="items-back-fill p-11 text-h3">Setup</div>
                                <div title="Vouchers master" className={`ui-items cursor  p-1 ${categorynameTab === "vouchers_master" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("vouchers_master");
                                        setcategoryproductsTabInUrl("vouchers_master");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40} className="items-center"><GrDocumentConfig className="icon-img" /></td>
                                                {collapsed === false && (
                                                    <td className="text-h2 fcap text-l">
                                                        Master
                                                    </td>
                                                )}
                                            </tr>
                                          
                                        </tbody>
                                    </table>
                                </div>
                                <div title="POS Receipt" className={`ui-items cursor  p-1 ${categorynameTab === "pos_receipt_master" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("pos_receipt_master");
                                        setcategoryproductsTabInUrl("pos_receipt_master");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40} className="items-center"><MdOutlineReceiptLong className="icon-img" /></td>
                                                {collapsed === false && (
                                                    <td className="text-h2 text-l fcap">
                                                        POS Receipts
                                                    </td>
                                                )}
                                            </tr>
                                        
                                        </tbody>
                                    </table>
                                </div>
                                <div className="items-back-fill p-11 text-h3">Report</div>
                                <div title="Account ledger" className={`ui-items cursor  p-1 ${categorynameTab === "account_ledger" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("account_ledger");
                                        setcategoryproductsTabInUrl("account_ledger");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40} className="items-center" ><PiBooks className="icon-img" /></td>

                                                {collapsed === false && (
                                                    <td className="text-h2 fcap text-l">
                                                        Ledger
                                                    </td>
                                                )}
                                            </tr>
 

                                        </tbody>
                                    </table>
                                </div>
                                <div title="Accounts master" className={`ui-items cursor  p-1 ${categorynameTab === "accounts_master" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("accounts_master");
                                        setcategoryproductsTabInUrl("accounts_master");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40} className="items-center"><MdOutlineManageAccounts className="icon-img" /></td>

                                                {collapsed === false && (
                                                    <td className="text-h2 fcap">
                                                        Accounts
                                                    </td>
                                                )}
                                            </tr>

                                          

                                        </tbody>
                                    </table>
                                </div>

                                <div title="Stock inventory" className={`ui-items cursor  p-1 ${categorynameTab === "stock_inventory" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("stock_inventory");
                                        setcategoryproductsTabInUrl("stock_inventory");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40} className="items-center"><MdOutlineInventory className="icon-img" /></td>


                                                {collapsed === false && (
                                                    <td className="text-h2 text-l  fcap">
                                                        Rent inventory
                                                    </td>
                                                )}

                                            </tr>
 

                                        </tbody>
                                    </table>
                                </div>

                                <div title="Receipt Transaction" className={`ui-items cursor p-1 ${categorynameTab === "receipt_transaction" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("receipt_transaction");
                                        setcategoryproductsTabInUrl("receipt_transaction");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40} className="items-center"  ><MdHistory className="icon-img" /></td>

                                                {collapsed === false && (
                                                    <td className="text-h2 text-l fcap">
                                                        Receipts Transaction
                                                    </td>
                                                )}
                                            </tr>
 

                                        </tbody>
                                    </table>
                                </div>
                                <div title="Reports" className={`ui-items cursor  p-1 ${categorynameTab === "cash_books" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("cash_books");
                                        setcategoryproductsTabInUrl("cash_books");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40} ><PiBooks className="icon-img" /></td>
                                                {collapsed === false && (
                                                    <td className="text-h2 text-l fcap">
                                                        <>Cash books</>
                                                    </td>
                                                )}
                                            </tr>
                                            

                                        </tbody>
                                    </table>
                                </div>

                                <div title="Vouchers list" className={`ui-items cursor p-1 ${categorynameTab === "vouchers" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                                    onClick={() => {
                                        setCategorynameTab("vouchers");
                                        setcategoryproductsTabInUrl("vouchers");
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40}><GrDocumentConfig className="icon-img" /></td>

                                                {collapsed === false && (
                                                    <td className=" text-h2 text-l bold fcap">
                                                        <>Vouchers</>
                                                    </td>
                                                )}
                                            </tr>
 

                                        </tbody>
                                    </table>
                                </div>
                                <div className="enablemenu text-l rounded">
                                    <Vouchers_list_menu collapsed={collapsed} />
                                </div>

                                <div title="Settings" className={`ui-items enablemenu cursor  p-1 menunonemenu  " : " menunonemenu"}`}

                                    onClick={() => navigate("/company")}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={40} ><MdSettings className="icon-img" /></td>

                                                {collapsed === false && (
                                                    <td className="text-h2 text-l bold fcap">
                                                        Settings
                                                    </td>
                                                )}
                                            </tr>
 

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div> */}
                    {/* <div className="products-container"> */}

                    <div className="container_roots" >
                    {ActivePage && <ActivePage />}
                    </div>
                    {/* </div>

                    </div> */}

                    <Chart_details />
                </>
                ) : (<Home_page />)}
        </div>
    );
}
